/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_No_ResultsInputs */

const th_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีผลการแข่งขัน`)
};

const en_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results yet.`)
};

const ja_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ結果はありません。`)
};

const zh_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无结果。`)
};

const es_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay resultados.`)
};

const pt_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado ainda.`)
};

const id_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada hasil.`)
};

const fr_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat pour l’instant.`)
};

const tl_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang resulta.`)
};

const vi_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có kết quả.`)
};

const ko_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 결과가 없습니다.`)
};

const de_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Ergebnisse.`)
};

const ru_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результатов пока нет.`)
};

const tr_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz sonuç yok.`)
};

const it_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun risultato.`)
};

const pl_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze wyników.`)
};

const uk_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результатів поки немає.`)
};

const hi_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई परिणाम नहीं।`)
};

const ar_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد نتائج بعد.`)
};

const ms_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada keputusan.`)
};

const bn_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও ফল নেই।`)
};

const zh_tw2_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無結果。`)
};

const zh_hk2_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無結果。`)
};

const ur_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی نتیجہ نہیں۔`)
};

const fa_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز نتیجه‌ای نیست.`)
};

const sw_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna matokeo bado.`)
};

const nl_event_no_results = /** @type {(inputs: Event_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen uitslagen.`)
};

/**
* | output |
* | --- |
* | "No results yet." |
*
* @param {Event_No_ResultsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_no_results = /** @type {((inputs?: Event_No_ResultsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_No_ResultsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_no_results(inputs)
	if (locale === "ja") return ja_event_no_results(inputs)
	if (locale === "zh") return zh_event_no_results(inputs)
	if (locale === "es") return es_event_no_results(inputs)
	if (locale === "pt") return pt_event_no_results(inputs)
	if (locale === "id") return id_event_no_results(inputs)
	if (locale === "fr") return fr_event_no_results(inputs)
	if (locale === "tl") return tl_event_no_results(inputs)
	if (locale === "vi") return vi_event_no_results(inputs)
	if (locale === "ko") return ko_event_no_results(inputs)
	if (locale === "de") return de_event_no_results(inputs)
	if (locale === "ru") return ru_event_no_results(inputs)
	if (locale === "tr") return tr_event_no_results(inputs)
	if (locale === "it") return it_event_no_results(inputs)
	if (locale === "pl") return pl_event_no_results(inputs)
	if (locale === "uk") return uk_event_no_results(inputs)
	if (locale === "hi") return hi_event_no_results(inputs)
	if (locale === "ar") return ar_event_no_results(inputs)
	if (locale === "ms") return ms_event_no_results(inputs)
	if (locale === "bn") return bn_event_no_results(inputs)
	if (locale === "zh-TW") return zh_tw2_event_no_results(inputs)
	if (locale === "zh-HK") return zh_hk2_event_no_results(inputs)
	if (locale === "ur") return ur_event_no_results(inputs)
	if (locale === "fa") return fa_event_no_results(inputs)
	if (locale === "sw") return sw_event_no_results(inputs)
	if (locale === "nl") return nl_event_no_results(inputs)
	return en_event_no_results(inputs)
});